export enum DATE_FORMAT {
  DD_MMM_YYYY = "dd MMM yyyy",
  "HH:mm" = "HH:mm",
  "HH:mm:ss" = "HH:mm:ss",
}
